module.exports = __webpack_public_path__ + "static/media/mmFront1.1fcfbd3b.jpg";